module.exports = __webpack_public_path__ + "src/assets/img/m26.147a828c.svg";